export class ViewPort {

    constructor(public width: number, public height: number) {

    }

    public get aspectRatio(): number {
        return this.width / this.height;
    }

    public toString(): string {
        return `${this.width} x ${this.height}`;
    }
}
